import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import logoImage from '@/assets/logos/logo.png'

interface HeaderProps {
  currentPage?: string    
}

export default function Header({ currentPage = 'home' }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  
  const navigation = [
    { name: 'Home', href: '/', current: currentPage === 'home' },
    { name: 'Services', href: '/services', current: currentPage === 'services' },
    { name: 'Our Work', href: '/work', current: currentPage === 'work' },
    { name: 'About', href: '/about', current: currentPage === 'about' },
    { name: 'Contact', href: '/contact', current: currentPage === 'contact' },
  ]

  return (
    <header className="bg-white shadow-sm border-b fixed top-0 left-0 right-0 z-50 w-full">
      <div className="container mx-auto px-4 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Logo Only */}
          <div className="flex items-center">
            <a href="/" className="hover:opacity-80 transition-opacity">
              <img 
                src={logoImage} 
                alt="TAKT Construction Services" 
                className="h-10 w-10 md:h-12 md:w-12 object-contain cursor-pointer"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={`transition-colors text-sm font-medium ${
                  item.current
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-50 w-full">
            <div className="px-4 py-6 space-y-4 w-full">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={`block text-base font-medium transition-colors ${
                    item.current
                      ? 'text-blue-600 border-l-4 border-blue-600 pl-3'
                      : 'text-gray-600 hover:text-blue-600 pl-3'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  )
} 